namespace TabAurous.HR {
    export interface PayrollForm {
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PayrollFrequency: Serenity.EnumEditor;
        LedgerId: Serenity.LookupEditor;
        BranchId: Serenity.LookupEditor;
        DepartmentId: Serenity.LookupEditor;
        DesignationId: Serenity.LookupEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        Details: PayrollDetailsEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
    }

    export class PayrollForm extends Serenity.PrefixedContext {
        static formKey = 'HR.Payroll';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PayrollForm.init)  {
                PayrollForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.EnumEditor;
                var w4 = s.LookupEditor;
                var w5 = s.DecimalEditor;
                var w6 = PayrollDetailsEditor;

                Q.initFormType(PayrollForm, [
                    'TransDate', w0,
                    'VoucherNo', w1,
                    'VoucherTypeId', w2,
                    'PayrollFrequency', w3,
                    'LedgerId', w4,
                    'BranchId', w4,
                    'DepartmentId', w4,
                    'DesignationId', w4,
                    'CurrencyId', w4,
                    'ExchRate', w5,
                    'Details', w6,
                    'CompanyId', w2,
                    'FinancialYearId', w2,
                    'UserId', w2
                ]);
            }
        }
    }
}
